/**
 * ScrollNav - Fixed right-side dot navigation + scroll-to-top
 * Dots centered vertically, scroll-to-top button anchored at bottom
 */

import React from 'react';
import { ScrollIndicator } from './ScrollIndicator';
import { ScrollToTopButton } from './ScrollToTopButton';

export function ScrollNav() {
  return (
    <aside
      id="scroll-nav"
      className="fixed right-5 top-0 bottom-0 w-10 flex flex-col items-center gap-6 z-[100] pointer-events-none [&>*]:pointer-events-auto pt-20 pb-8"
      aria-hidden="true"
    >
      <div className="flex-1 flex items-center justify-center min-h-0">
        <ScrollIndicator />
      </div>
      <div className="flex-shrink-0">
        <ScrollToTopButton />
      </div>
    </aside>
  );
}
